import ManageRetailSpaces from './ManageRetailSpaces';

export default ManageRetailSpaces;
